const auth = {
	title: "Inlogging",
	sign_in: "Logg inn i admin portal",
	login_error: "Feil brukernavn og/eller passord. Vennligst prøv igjen.",
	login: "Logg inn",
	logout: "Logg ut",
	email: "Epost",
	password: "Passord",
	mobile: "Mobil",
	change_password: "Endre passord",
	update_password: "Oppdatere passord",
	current_password: "Nåværende passord",
	set_password: "Endre passord",
	update_password_error: "Oppdatering av passord feilet. Vennligst prøv igjen.",
	password_does_not_match_error: "Passord er ikke like",
	new_password: "Nytt passord",
	new_password_retype: "Gjenta nytt passord",
	remember: "Husk meg",
	sign_up: "Registrer",
	no_account: "Har du ikke konto?",
	success: "Vellykket",
	error: "Feil",
	register: "Registrer",
	register_person: "Registreringskjema (Bruker)",
	register_company: "Registreringskjema (Selskap)",
	register_success: "Vellykket registrering.",
	verification: "Verifisering",
	verify: "Verifiser",
	code: "6 tall kode",
	code_instruction: "6 sifret kode er blitt sent til din epost.",
	code_enter: "Skriv inn kode",
	code_enter_failed: "Feil kode",
	pincode_title: "Tast inn pin kode",
	reenter_pincode_title: "Repeter kode",
	newpincode_title: "Tast inn ny kode",
	currentpincode_title: "Tast inn pin kode",
	invalid_pincode: "Feil pin",
	mismatch_pincode: "pin samsvarer ikke",
	success_pincode: "Pin kode oppdatert.",
	login_email: "Logg inn med epost",
	login_mobile: "Logg inn med mobil",
	login_feide: "Logg inn med Feide",
	sms_code: "SMS kode",
	enter_code: "Tast inn kode",
	enter_code_sms: "Kode sendt til {mobile}",
	sms_otp_send_failed: "SMS ikke sendt. Ta kontakt med XL3.no",
	sms_otp_incorrect_code: "Feil eller utløpt kode",
	error_user_already_an_employee: "Bruker er allerede tildelt denne bedriften",
	error_user_pending_request: "Bruker har allerede sendt forespørsel og venter på svar.",
	error_feide_invalid_authorization_url: "Feilet å logge inn med Feide. Kontakt administrator.",
	error_feide_failed_to_generate_token: "Kunne ikke generere autorisasjonstoken. Vennligst kontakt administrator",
	feide_want_to_add: "Bruker {name} ({email}) er ikke registrert i Kompetanse web. Vil du registrere deg som bruker ?",
	feide_no_add: "Bettingelser ble ikke akseptert. Avbryter innlogging. ",
	privacy_policy_title: "Personvernerklæring",
	privacy_consent_to: "Jeg godtar",
	privacy_notice: "Personvernerklæringen",
	privacy_close: "Lukk",
	forgot: {
		back: "Tilbake",
		send_request: "Gjenopprett passord ",
		forgot_t: "Glemt passord",
		confirm_pass: "Bekreft passord",
		forgot: "Glemt passord?",
		invalidrequest_t: "Feil ved forespørsel",
		invalidrequest_m: "Ugyldig link.",
		reset_t: "Gjennopprett passord",
		reset_pass: "Forny passord",
		reset_success_m: "Nytt passord er satt!",
		reset_error_m: "Kan ikke endre passord akkurat nå. Vennligst prøv igjen senere.",
		forgot_success_m: "Link for passordgjenoppretting er sendt til ",
		forgot_error_m: "Kan ikke sende akkurat nå. Vennligst prøv igjen senere.",
		unregistered: " er ikke registrert.",
		invalid_token: "Ugyldig link.",
		invalid_email: "Ugyldig epostadresse.",
		valid_token: "Nytt passord er sendt til epost ({email})",
		expired_token: "Passord link utløpt.",
	},
};
export default auth;